export default {
  // ********************************************************
  //
  // SIMPLIFIED CHINESE
  //
  // ********************************************************
  cn: {
    page_title: '页面标题',
    wechat: {
      generic: {
        title: '测试标题',
        desc: '测试说明',
        moments: '测试朋友圈',
      },
    },
    start: {
      soundCta: '请打开手机声音',
    },
    agegate: {
      above18: '你是否满18周岁',
      yes: '是的',
      tc: {
        agree: '我已阅读并同意',
        terms: '使用条款',
        and: '和',
        conditions: '隐私条款',
      },
    },
    tc: {
      close: '下一步',
      content: [
        '一、协议的范围 1.1 协议适用主体范围 本协议是你与腾讯之间关于你下载、安装使用、复制本软件，以及使用腾讯相关服务所订立的协议。 1.2 协议关系及冲突条款 本协议被视为《腾讯服务协议》及 《QQ号码规则》的补充协议，是其不可分割的组成部分，与其构成统一整体本协议与上述内容存在冲突的，以本协议为准。 本协议内容同时包括腾讯可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，你同样应当遵守。 二、关于本服务 2.1 本服务的内容 本服务内容是指腾讯向用户提供的跨平台的通讯工具（以下简称“微信”），支持单人、多人参与，在发送语音短信、视频、图片和文字等即时通讯服务的基础上，同时为用户提供包括但不限于关系链拓展、便捷工具、微信公众帐号、开放平台、与其他软件或硬件信息互通等功能或内容的软件许可及服务（以下简称“本服务”）。 2.2 本服务的形式',
        '一、协议的范围 1.1 协议适用主体范围 本协议是你与腾讯之间关于你下载、安装使用、复制本软件，以及使用腾讯相关服务所订立的协议。 1.2 协议关系及冲突条款 本协议被视为《腾讯服务协议》及 《QQ号码规则》的补充协议，是其不可分割的组成部分，与其构成统一整体本协议与上述内容存在冲突的，以本协议为准。 本协议内容同时包括腾讯可能不断发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，你同样应当遵守。 二、关于本服务 2.1 本服务的内容 本服务内容是指腾讯向用户提供的跨平台的通讯工具（以下简称“微信”），支持单人、多人参与，在发送语音短信、视频、图片和文字等即时通讯服务的基础上，同时为用户提供包括但不限于关系链拓展、便捷工具、微信公众帐号、开放平台、与其他软件或硬件信息互通等功能或内容的软件许可及服务（以下简称“本服务”）。 2.2 本服务的形式',
      ],
    },
    contact: {
      info: {
        title: '马爹利蓝带',
        desc: '盛宴风味, 百年经典XO, 集10升葡萄\n精粹于一瓶, 酒香馥郁, 圆润优雅。',
        btnHub: '探索其他桌',
        btnProduct: '了解这一瓶',
      },

      step1: {
        desc: '立享专属折扣及大众点评优惠\n更可赢取线下好奇盛宴入场券',
        phone: '电话',
        btn: '下一步',
      },

      step2: {
        desc: '以下为选填信息',
        name: '姓名',
        city: '城市',
        male: '先生',
        female: '女士',
        age0: '18-25岁',
        age1: '26-35岁',
        age2: '36岁以上',
        btn: '提交',
      },

      step3: {
        desc: 'Thank!\nYour will receive your voucher\non a text message.\nEnjoy Martel.',
        btn: '提交',
      },
    },
    ui: {
      shake: '摇摇手机 改变局面',
      tilt: '移动手机 开始探索',
      tap: '点击区域 和她搭话',
    },
    end: {
      distinction: {
        title: '马爹利蓝带',
        subtitle: '盛宴风味, 百年经典XO, 集10升葡萄精粹于一瓶, 酒香馥郁, 圆润优雅。',
      },
      cb: {
        title: '马爹利蓝带',
        subtitle: '盛宴风味, 百年经典XO, 集10升葡萄精粹于一瓶, 酒香馥郁, 圆润优雅。',
      },
      cbe: {
        title: '马爹利蓝带',
        subtitle: '盛宴风味, 百年经典XO, 集10升葡萄精粹于一瓶, 酒香馥郁, 圆润优雅。',
      },
      done: '您已成功探寻此桌之味',
      toHub: '探索其他桌',
      toProduct: '细品这一瓶',
      toContact: '前往选填信息',
      wechat: {
        desc: '尊享专属优惠及好礼,\n更可亲莅线下好奇盛宴',
        cta: '长按扫描 关注公众号',
      },
    },
    product: {
      distinction: {
        title: '以层层的馥郁芬芳\n开启所有感官体验\n在每一场盛宴\n干杯为美好的发生',
        desc: [
          '马爹利鼎盛是一款汲取葡萄精华，经匠心调和而成，适合搭配各种美食的VSOP级别干邑。易入口的圆润和细腻，丰富的口感层次，让任何食客都无力抵抗它在余韵中蕴散出的悠长果香和强劲回甘。',
          '遇到对味的酒，任何一道食物都会是珍馐。\n所有食物对马爹利鼎盛都是一见钟情。\n五滋六味的佛跳墙与它惺惺相惜，豪迈过瘾的川香辣子鸡也对它相见恨晚，清而不淡、嫩而不生的粤菜做法数都数不过来,',
          '但每种口味和它交织在一起，也都浑然天成。谁会想到，世界上能和马爹利鼎盛热烈互动的菜色竟有如此之多。面对无穷的可能性，换了谁，都忍不住要设计各种排列组合，只为品尝惊艳的撞味风情。',
        ],
      },
      cb: {
        title: '以层层的馥郁芬芳\n开启所有感官体验\n在每一场盛宴\n干杯为美好的发生',
        desc: [
          '马爹利鼎盛是一款汲取葡萄精华，经匠心调和而成，适合搭配各种美食的VSOP级别干邑。易入口的圆润和细腻，丰富的口感层次，让任何食客都无力抵抗它在余韵中蕴散出的悠长果香和强劲回甘。',
          '遇到对味的酒，任何一道食物都会是珍馐。\n所有食物对马爹利鼎盛都是一见钟情。\n五滋六味的佛跳墙与它惺惺相惜，豪迈过瘾的川香辣子鸡也对它相见恨晚，清而不淡、嫩而不生的粤菜做法数都数不过来,',
          '但每种口味和它交织在一起，也都浑然天成。谁会想到，世界上能和马爹利鼎盛热烈互动的菜色竟有如此之多。面对无穷的可能性，换了谁，都忍不住要设计各种排列组合，只为品尝惊艳的撞味风情。',
        ],
      },
      cbe: {
        title: '以层层的馥郁芬芳\n开启所有感官体验\n在每一场盛宴\n干杯为美好的发生',
        desc: [
          '马爹利鼎盛是一款汲取葡萄精华，经匠心调和而成，适合搭配各种美食的VSOP级别干邑。易入口的圆润和细腻，丰富的口感层次，让任何食客都无力抵抗它在余韵中蕴散出的悠长果香和强劲回甘。',
          '遇到对味的酒，任何一道食物都会是珍馐。\n所有食物对马爹利鼎盛都是一见钟情。\n五滋六味的佛跳墙与它惺惺相惜，豪迈过瘾的川香辣子鸡也对它相见恨晚，清而不淡、嫩而不生的粤菜做法数都数不过来,',
          '但每种口味和它交织在一起，也都浑然天成。谁会想到，世界上能和马爹利鼎盛热烈互动的菜色竟有如此之多。面对无穷的可能性，换了谁，都忍不住要设计各种排列组合，只为品尝惊艳的撞味风情。',
        ],
      },
      toHub: '探索其他桌',
      toProducts: '探索其他酒',
      toBuy: 'Buy',
    },
  },

  // ********************************************************
  //
  // ENGLISH
  //
  // ********************************************************
  en: {
    page_title: 'PAGE_TITLE',
    wechat: {
      generic: {
        title: 'TEST_TITLE',
        desc: 'TEST_DESC',
        moments: 'TEST_MOMENTS',
      },
    },
  },
}
